import { Dialog, Slide } from '@mui/material';
import Modal from './Modal';

export const EditModal = ({ onHide, isVisible, contentDetails, uploadType, uniqueId, setContentDetails, makeEveryThingNull }) => (
  <Dialog
    onClose={onHide}
    open={isVisible}
    PaperComponent={Modal}
    PaperProps={{ onHide, isVisible, contentDetails, uploadType, uniqueId, setContentDetails, makeEveryThingNull }}
    TransitionComponent={Slide}
    transitionDuration={isVisible ? 300 : 250}
    TransitionProps={{ direction: 'up' }}
  />
);
